<template>
  <div class="featured relative flex">
    <div class="information" :class="categorySlug">
      <div class="top-spacing"></div>
      <div class="featured-banner" :class="categorySlug">
      </div>
      <div class="flex ml-3 my-2">
        <div class="offset-lg-1 col-10 featured-title">
            <h3>{{ article.first_name }} {{ article.last_name }}</h3>
        </div>
      </div>
      <div class="flex ml-3">
        <div class="offset-lg-1 col">
          <router-link :to="articleLink" class="bg-white text-grey-2 rounded-full body-13">Click to view project</router-link>
        </div>
      </div>
    </div>
    <div class="featured-image" :style="{backgroundImage: `url(${article.featured_image_url})`}"></div>
    <img :alt="articleImgAlt" :src="`${article.featured_image_url}`" class="hidden"/>
  </div>
</template>

<script>
  import { isDefined } from '@/common/utils/utils';

  export default {
    name: 'LernerFeatured',
    props: ['article'],

    data() {
      return {
        ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,
      }
    },

    computed: {
      articleLink: function () {
        return {
          name: 'article',
          params: {
            article: this.article.slug,
            category: this.categorySlug
          }
        }
      },
      articleImgAlt: function () {
        return `${this.article.first_name} ${this.article.last_name}`
      },
      categorySlug: function() {
        if (isDefined(this.article.categories) && this.article.categories.length) {
          return this.article.categories[0].slug;
        }

        return 'default';
      }
    }
  }
</script>

<style lang="scss" scoped>
  .featured {
    height: 520px;

    .featured-banner {
      width: 270px;
      height: 74px;

      &.craft {
        background-image: url("~@/assets/images/craft-category-featured-bar.svg");
      }

      &.build {
        background-image: url("~@/assets/images/build-category-featured-bar.svg");
      }

      &.experiment {
        background-image: url("~@/assets/images/experiment-category-featured-bar.svg");
      }

      &.eat {
        background-image: url("~@/assets/images/eat-category-featured-bar.svg");
      }

      &.celebrate {
        background-image: url("~@/assets/images/celebrate-category-featured-bar.svg");
      }
    }

    .information {
      height: 520px;
      @apply absolute pin-t pin-l z-10;
      width: 50%;
      background-position-x: right;
      background-repeat: no-repeat;

      h3 {
        line-height: 1.2;
      }

      @media (min-width: config('screens.xl')) {
        background-position-x: left;
      }

      &.craft {
        background-image: url("../assets/images/craft-category-featured.svg");
      }

      &.build {
        background-image: url("../assets/images/build-category-featured.svg");
      }

      &.experiment {
        background-image: url("../assets/images/experiment-category-featured.svg");
      }

      &.eat {
        background-image: url("../assets/images/eat-category-featured.svg");
      }

      &.celebrate {
        background-image: url("../assets/images/celebrate-category-featured.svg");
      }
    }

    .featured-title {
      @apply text-white;
      word-break: break-word;
    }

    .featured-image {
      position: absolute;
      top: 0;
      right: 0;
      width: 60%;
      height: 520px;
      background-size: cover;
      background-position: center;
    }
  }


  .top-spacing {
    height: 80px;
  }

  a {
    padding: 6px 15px;
  }

  hr {
    width: 80%;
    height: 2px;
    @apply mb-9 ml-0 bg-white;
  }
</style>
